//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import {getReport,getReportMore} from '@/api/iapc';
import global_ from '../../components/Global'
import VueQr from 'vue-qr';
export default {

  data() {
    return {
      newsId:'',
      userId:'',
      studentId:'',
      reportInfo:{},
      studyInfo:{},
      commentInfo:{},
      shareInfo:{},
      qrUrl:'',
      isShowCommentMore:false,
      isShowStudyMore:false,
      studyMore:[],
      commentMore:[],
      shareMore:[],
      studentPageNo:2,
      commentPageNo:2,
      showCancelMessage:false,
      messageContent:'没有更多数据',
    };
  },
  components: {
    VueQr
  },
  methods: {
    getReport(){
      let params = {studentId:this.studentId}
      getReport(params).then((res) => {
        if(res.code == 0){
          this.reportInfo = res.data;
          this.studyInfo = this.reportInfo.studyInfo;
          this.commentInfo = this.reportInfo.commentInfo;
          this.shareInfo = this.reportInfo.shareInfo;
          if(this.studyInfo.content.length > 0){
            this.isShowStudyMore = true;
          }
          if(this.commentInfo.content.length > 0){
            this.isShowCommentMore = true;
          }
        }
      })
    },
    getStudentMore(){
      let params = {studentId:this.studentId,type:0,pageNo:this.studentPageNo}
      getReportMore(params).then((res) => {
        if(res.code == 0){
          if(res.data.content.length > 0){
            for(var i=0;i<res.data.content.length;i++){
              this.studyInfo.content.push(res.data.content[i])
            }
          }else{
              this.isShowStudyMore = false;
          }
        }
        this.studentPageNo++
      })
    },
    getCommentMore(){
      let params = {studentId:this.studentId,type:1,pageNo:this.commentPageNo}
      getReportMore(params).then((res) => {
        if(res.code == 0){
          if(res.data.content.length > 0){
            for(var i=0;i<res.data.content.length;i++){
              this.commentInfo.content.push(res.data.content[i])
            }
          }else{
            this.isShowCommentMore = false;
          }

        }
        this.commentPageNo++
      })
    }

  },
  mounted () {
    if (typeof(this.$route.query.studentId) == "undefined" || this.$route.query.studentId == ""){
      this.$router.push("/error/201");
    }else{
      this.studentId = this.$route.query.studentId;
      this.getReport();
    }
    this.qrUrl = global_.shareSrc+'iapc/share_report?studentId='+this.studentId;
  },
};





// WEBPACK FOOTER //
// ./src/pages/iapc/report.vue